import axios from '../../axios';

const feedBackInfoSelect = 'Contact($select=title,firstName,lastName),BookingItems($select=title,propertyId,dateIn,DateOut,property;$expand=property($select=regionId,SubRegionId)),ExperienceItems($select=title,serviceId,service;),savedFeedback($select=*;$expand=regionsInterestedIn,regionRatings,itemRatings,nonBooker_WhyDidYouNotBookTypes,howDidYouFindTTT)';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {

    // example: data = {id : 8848829374612, guid : 177589d3-e5e5-4d2a-8d88-afbc44b7f50e}
    getFeedbackInfo({}, data) {
      return new Promise((resolve, reject) => {
        if (data.feedbackId) {
          axios.get(`core/feedback/feedbackid/${data.feedbackId}/guid/${data.guid}?$select=*&$expand=${feedBackInfoSelect}`).then((res) => resolve(res)).catch((error) => reject(error));
        }
        else if (data.bookingId) {
          // old - todo remove in 2022 season.
          axios.get(`core/feedback/bookingid/${data.bookingId}/guid/${data.guid}?$select=*&$expand=${feedBackInfoSelect}`).then((res) => resolve(res)).catch((error) => reject(error));
        }
      });
    },

    // example: data = {}
    postFeedBack({ }, feedback) {
      return new Promise((resolve, reject) => {
        axios.post('core/feedback', feedback).then((res) => resolve(res)).catch((error) => reject(error));
      });
    },

  },
};
